// Module
var code = "<cButton class=\"emailButton_linkContainer\"> <a class=\"emailButton_link t-thankYouPage_gmailButton\" :href=\"emailLink\" target=\"_blank\" @click.passive.once=\"openEmail()\"> {{ t(text) }} </a> </cButton> ";
// Exports
export default code;